import './pricing-calculator';

(function() {
  $('.unreg-cards-section .card').mouseleave(e => {
    $(e.target || e.srcElement).addClass('hide-pulser');
  });
})();
